import * as React from 'react';
import { sectionFactory } from '../SectionFactory';

const DataList = sectionFactory('data-list')
const DataListRow = sectionFactory('data-list-row')
const DataListRowLink = sectionFactory('data-list-row data-list-row-link')
const DataListHeader = sectionFactory('data-list-header')

export {
  DataList,
  DataListRow,
  DataListRowLink,
  DataListHeader,
}
